import { render } from "./studentList.vue?vue&type=template&id=b9ad3ec6&scoped=true"
import script from "./studentList.vue?vue&type=script&lang=js"
export * from "./studentList.vue?vue&type=script&lang=js"

import "./studentList.vue?vue&type=style&index=0&id=b9ad3ec6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9ad3ec6"]])

export default __exports__